export default __webpack_public_path__ + "static/media/healthmap-logo.7e37ef87.svg";